import { createSelector } from '@ngrx/store';

import { paymentState } from '../root';

export const getPaymentStepsStatus = createSelector(paymentState, (payment) => payment.paymentStepStatus);
